import { vehicleType } from '../constants/vehicleType';
import { TtFuelType } from '../gql/generated/graphql';
import { formatMileage } from './helpers';

export type MarketplaceVehicle = {
  year?: number | null;
  make?: string | null;
  model?: string | null;
  mileage?: number | null;
};

export const formatVehicleTitle = ({ year, make, model }: MarketplaceVehicle): string => {
  const parts = [year, make, model].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : 'Your vehicle';
};

export const formatVehicleSummary = ({
  year,
  make,
  model,
  mileage,
}: MarketplaceVehicle): string => {
  const name = [year, make, model].filter(Boolean).join(' ');
  const miles = formatMileage(mileage);
  return miles !== '' ? `${name} · ${miles} mi` : name;
};

const TRIM_EXPLANATION = `
  Trim is basically a fancy term for the different features and options that come with a specific
  model of car. This can include everything from the engine and transmission to exterior and
  interior upgrades. The trim is usually located on the inside of the driver's side door or in
  the owner's manual.
`;

const fuelTypeOptions = [
  { label: TtFuelType.Gasoline, value: TtFuelType.Gasoline },
  { label: TtFuelType.Electric, value: TtFuelType.Electric },
  { label: TtFuelType.Hybrid, value: TtFuelType.Hybrid },
  { label: TtFuelType.Diesel, value: TtFuelType.Diesel },
];

const vehicleTypeOptions = [
  { label: 'Sedan', value: vehicleType.PASSENGER },
  { label: 'Truck', value: vehicleType.TRUCK },
  { label: 'SUV/Van/Crossover', value: vehicleType.MPV },
];

export { fuelTypeOptions, vehicleTypeOptions, TRIM_EXPLANATION };
